import { SettingsEndpoint } from '@constants/ApiEndpoints';
import { AxiosInstance } from 'axios';
import { FetchingRequestParamsModels } from 'models/Shared/FetchingRequestParamsModels';
import { PaymentGroupModel } from '../../../models/Settings/Financial/PaymentGroupModel';

export interface Options {
  id: number;
  label: string;
}

export interface TypeModel {
  id: string | undefined;
  value: string | number;
  label: string;
}

export const remove =
  (axios: AxiosInstance) =>
  async (id: number): Promise<PaymentGroupModel> => {
    return await axios.delete(`${SettingsEndpoint.SETTINGS_FINANCIAL_PAYMENT_GROUPS}/${id}`);
  };

export const getAll =
  (axios: AxiosInstance) =>
  async (
    params?: FetchingRequestParamsModels
  ): Promise<{ items: PaymentGroupModel[]; total: number }> => {
    return await axios
      .get(SettingsEndpoint.SETTINGS_FINANCIAL_PAYMENT_GROUPS, {
        params,
      })
      .then(({ data }) => data);
  };

export const create =
  (axios: AxiosInstance) =>
  async (data: Partial<PaymentGroupModel>): Promise<PaymentGroupModel> => {
    return await axios
      .post(SettingsEndpoint.SETTINGS_FINANCIAL_PAYMENT_GROUPS, data)
      .then(({ data }) => data);
  };

export const update =
  (axios: AxiosInstance) =>
  async (data: Partial<PaymentGroupModel>): Promise<PaymentGroupModel> => {
    return await axios
      .put(`/${SettingsEndpoint.SETTINGS_FINANCIAL_PAYMENT_GROUPS}/${data.id}`, data)
      .then(({ data }) => data);
  };

export const toggleStatus =
  (axios: AxiosInstance) =>
  async (id: number): Promise<PaymentGroupModel> => {
    return await axios
      .patch(`/${SettingsEndpoint.SETTINGS_FINANCIAL_PAYMENT_GROUPS}/${id}`)
      .then(({ data }) => data);
  };
